import React from 'react';

/**
 * ContentLoader
 * Loader genérico para pantallas que usan Suspense a nivel de la aplicación.
 * - Muestra un spinner centrado y un mensaje opcional.
 * - Incluye atributos de accesibilidad para lectores de pantalla.
 */
export const ContentLoader = ({ message = 'Cargando...' }) => {
  return (
    <div 
      className="min-h-[50vh] flex flex-col items-center justify-center text-white"
      role="status"
      aria-live="polite"
      aria-label={message}
    >
      <div className="h-10 w-10 border-4 border-white/30 border-t-white rounded-full animate-spin mb-4" />
      <span className="text-sm opacity-80">{message}</span>
    </div>
  );
};

export default ContentLoader;